module.exports = __webpack_public_path__ + "public/adminIcons/manageServiceFee.svg?c2c62c3d";